import { render, staticRenderFns } from "./ModalConfirmPayment.vue?vue&type=template&id=405120bb&scoped=true&"
import script from "./ModalConfirmPayment.vue?vue&type=script&lang=js&"
export * from "./ModalConfirmPayment.vue?vue&type=script&lang=js&"
import style0 from "./ModalConfirmPayment.vue?vue&type=style&index=0&id=405120bb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405120bb",
  null
  
)

export default component.exports